import * as ambassadorWixBookingsV1Category from './bookings-v1-category-categories.http.js';
import * as ambassadorWixBookingsV1CategoryTypes from './bookings-v1-category-categories.types.js';
import * as ambassadorWixBookingsV1CategoryUniversalTypes from './bookings-v1-category-categories.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listCategories(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsV1CategoryUniversalTypes.ListCategoryRequest,
  ambassadorWixBookingsV1CategoryTypes.ListCategoryRequest,
  ambassadorWixBookingsV1CategoryUniversalTypes.ListCategoryResponse,
  ambassadorWixBookingsV1CategoryTypes.ListCategoryResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBookingsV1Category.list(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/categories',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCategory(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV1CategoryUniversalTypes.CreateCategoryRequest,
  ambassadorWixBookingsV1CategoryTypes.CreateCategoryRequest,
  ambassadorWixBookingsV1CategoryUniversalTypes.CreateCategoryResponse,
  ambassadorWixBookingsV1CategoryTypes.CreateCategoryResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBookingsV1Category.create(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/categories',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCategory(): __PublicMethodMetaInfo<
  'PUT',
  { categoryId: string },
  ambassadorWixBookingsV1CategoryUniversalTypes.UpdateCategoryRequest,
  ambassadorWixBookingsV1CategoryTypes.UpdateCategoryRequest,
  ambassadorWixBookingsV1CategoryUniversalTypes.UpdateCategoryResponse,
  ambassadorWixBookingsV1CategoryTypes.UpdateCategoryResponse
> {
  const payload = { category: { id: ':categoryId' } } as any;

  const getRequestOptions = ambassadorWixBookingsV1Category.update(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/categories/{category.id}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCategory(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixBookingsV1CategoryUniversalTypes.DeleteCategoryRequest,
  ambassadorWixBookingsV1CategoryTypes.DeleteCategoryRequest,
  ambassadorWixBookingsV1CategoryUniversalTypes.DeleteCategoryResponse,
  ambassadorWixBookingsV1CategoryTypes.DeleteCategoryResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixBookingsV1Category._delete(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/categories/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Category as CategoryOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  ListCategoryRequest as ListCategoryRequestOriginal,
  ListCategoryResponse as ListCategoryResponseOriginal,
  CategoryNotification as CategoryNotificationOriginal,
  Event as EventOriginal,
  EventWithLiterals as EventWithLiteralsOriginal,
  CreateCategoryRequest as CreateCategoryRequestOriginal,
  CreateCategoryResponse as CreateCategoryResponseOriginal,
  BatchCreateCategoryRequest as BatchCreateCategoryRequestOriginal,
  BatchCreateCategoryResponse as BatchCreateCategoryResponseOriginal,
  UpdateCategoryRequest as UpdateCategoryRequestOriginal,
  UpdateCategoryResponse as UpdateCategoryResponseOriginal,
  DeleteCategoryRequest as DeleteCategoryRequestOriginal,
  DeleteCategoryResponse as DeleteCategoryResponseOriginal,
  BatchDeleteCategoryRequest as BatchDeleteCategoryRequestOriginal,
  BatchDeleteCategoryResponse as BatchDeleteCategoryResponseOriginal,
  BatchUpdateCategoryRequest as BatchUpdateCategoryRequestOriginal,
  BatchUpdateCategoryResponse as BatchUpdateCategoryResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateApplicationErrors as UpdateApplicationErrorsOriginal,
} from './bookings-v1-category-categories.types.js';
